import { BADGE_VARIANTS } from 'components/Badge'
import { PRODUCT_STATUSES } from 'constants/common'
import { type StatusBadgeMapper } from './types'

export const PRODUCT_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [PRODUCT_STATUSES.PUBLISHED]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [PRODUCT_STATUSES.NOT_PUBLISHED]: {
    variant: BADGE_VARIANTS.RED,
  },
  [PRODUCT_STATUSES.ARCHIVED]: {
    variant: BADGE_VARIANTS.BROWN,
  },
  [PRODUCT_STATUSES.PENDING_APPROVAL]: {
    variant: BADGE_VARIANTS.ORANGE,
  },
} as const
